import React, { useState } from 'react';
import { MatchPeople } from './MatchPeople';
import { MatchConnections } from './MatchConnections';
import { ArrowLeft, Filter, X } from 'lucide-react';
interface Props {
  onScanPress: () => void; // Kept for compatibility, but unused in UI
}
const AVAILABLE_THEMES = ['AI Governance', 'Climate Finance', 'Supply Chain', 'Water Security', 'Clean Energy', 'Impact Investing'];
export function MatchContainer({
  onScanPress
}: Props) {
  const [view, setView] = useState<'people' | 'connections'>('people');
  const [selectedThemes, setSelectedThemes] = useState<string[]>([]);
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const handleBackToPeople = () => {
    setView('people');
  };
  const toggleTheme = (theme: string) => {
    setSelectedThemes(prev => prev.includes(theme) ? prev.filter(t => t !== theme) : [...prev, theme]);
  };
  const showBack = view === 'connections';
  const getTitle = () => {
    if (view === 'connections') return 'Le tue connessioni';
    return 'Match';
  };
  const getSubtitle = () => {
    if (view === 'connections') return '2 persone con cui hai fatto match';
    return 'Scopri chi è interessato';
  };
  return <div className="flex flex-col h-full w-full bg-[#0D0D0D] overflow-hidden relative" data-id="element-207">
      {/* Fixed Header */}
      <div className="bg-[#0D0D0D] border-b border-[#2A2A2A]/50 px-6 pt-10 pb-4 flex items-center justify-between gap-3 flex-shrink-0" data-id="element-208">
        <div className="flex items-center gap-3 flex-1 min-w-0" data-id="element-209">
          {showBack && <button onClick={handleBackToPeople} className="w-8 h-8 rounded-full bg-[#141414] border border-[#2A2A2A] flex items-center justify-center text-white active:scale-95 transition-all flex-shrink-0" data-id="element-210">
              <ArrowLeft className="w-4 h-4" data-id="element-211" />
            </button>}
          <div className="min-w-0" data-id="element-212">
            <h1 className="font-medium text-white text-[17px] tracking-tight truncate" data-id="element-213">
              {getTitle()}
            </h1>
          </div>
        </div>

        {/* Filter Button (replaces Scan) */}
        {view === 'people' && <button onClick={() => setIsFilterOpen(true)} className={`bg-transparent border rounded-full px-4 py-1.5 flex items-center gap-2 active:scale-95 transition-all duration-200 flex-shrink-0 ${selectedThemes.length > 0 ? 'border-[#C5D82D] text-[#C5D82D]' : 'border-[#2A2A2A] text-white'}`} data-id="element-214">
            <Filter className="w-3.5 h-3.5" strokeWidth={2.5} data-id="element-215" />
            <span className="text-[12px] font-medium" data-id="element-216">
              Filtra {selectedThemes.length > 0 && `(${selectedThemes.length})`}
            </span>
          </button>}
      </div>

      {/* Content */}
      <div className="flex-1 overflow-hidden min-h-0" data-id="element-217">
        {view === 'people' && <MatchPeople selectedThemes={selectedThemes} onViewConnections={() => setView('connections')} data-id="element-218" />}
        {view === 'connections' && <MatchConnections onBack={handleBackToPeople} data-id="element-219" />}
      </div>

      {/* Theme Filter Modal */}
      {isFilterOpen && <div className="absolute inset-0 z-50 flex flex-col justify-end" data-id="element-220">
          {/* Backdrop */}
          <div className="absolute inset-0 bg-black/60 backdrop-blur-sm animate-in fade-in duration-200" onClick={() => setIsFilterOpen(false)} data-id="element-221" />

          {/* Bottom Sheet */}
          <div className="relative bg-[#141414] border-t border-[#2A2A2A] rounded-t-2xl pt-6 pb-8 px-6 animate-in slide-in-from-bottom-full duration-300" data-id="element-222">
            <div className="flex items-center justify-between mb-6" data-id="element-223">
              <h2 className="text-[18px] font-medium text-white tracking-tight" data-id="element-224">
                Filtra per tema
              </h2>
              <button onClick={() => setIsFilterOpen(false)} className="w-8 h-8 rounded-full bg-[#1A1A1A] flex items-center justify-center text-[#888888] active:scale-95" data-id="element-225">
                <X className="w-4 h-4" data-id="element-226" />
              </button>
            </div>

            <div className="flex flex-wrap gap-2.5 mb-8" data-id="element-227">
              {AVAILABLE_THEMES.map(theme => {
            const isSelected = selectedThemes.includes(theme);
            return <button key={theme} onClick={() => toggleTheme(theme)} className={`
                      px-4 py-2 rounded-full text-[13px] font-medium transition-all duration-200 border
                      ${isSelected ? 'bg-[#C5D82D] border-[#C5D82D] text-[#0D0D0D]' : 'bg-transparent border-[#2A2A2A] text-white hover:border-[#555555]'}
                    `} data-id="element-228">
                    {theme}
                  </button>;
          })}
            </div>

            <div className="flex gap-3" data-id="element-229">
              <button onClick={() => setSelectedThemes([])} className="flex-1 py-3.5 rounded-full border border-[#2A2A2A] text-white text-[14px] font-medium active:scale-95 transition-all" data-id="element-230">
                Mostra tutti
              </button>
              <button onClick={() => setIsFilterOpen(false)} className="flex-1 py-3.5 rounded-full bg-[#C5D82D] text-[#0D0D0D] text-[14px] font-medium active:scale-95 transition-all" data-id="element-231">
                Applica
              </button>
            </div>
          </div>
        </div>}
    </div>;
}